import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@/api/settings';
import { queryKeys } from '@/api/query-keys';

/** Server configuration. Cached aggressively: it changes only on redeploy. */
export function useSettings() {
  return useQuery({
    queryKey: queryKeys.settings,
    queryFn: settingsApi.get,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}

export function useHealth(enabled = true) {
  return useQuery({
    queryKey: queryKeys.health,
    queryFn: settingsApi.health,
    enabled,
    refetchInterval: 30_000,
    retry: 1,
  });
}
